import React from "react";
export const NoContentMessage = (props) => {
    const { messages, backgroundColour = "bg-light-gray" } = props;
    return (React.createElement("div", { className: `flex flex-col justify-center py-6 px-4 w-full h-full items-center ${backgroundColour} rounded-lg text-dark-gray font-normal text-center text-base` }, messages.map((i, index) => (React.createElement("div", { key: index }, i)))));
};
